import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4599f8c2")

_pushScopeId("data-v-4599f8c2")
const _hoisted_1 = { class: "button-frame" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("＋追加")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_validate_edit_box = _resolveComponent("validate-edit-box")
  const _component_icon_button_large = _resolveComponent("icon-button-large")
  const _component_normal_button = _resolveComponent("normal-button")

  return (_openBlock(), _createBlock("div", null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.values, (_, i) => {
      return (_openBlock(), _createBlock("div", {
        key: `number-${i}`,
        class: "number-row vue-content-edit-box"
      }, [
        _createVNode(_component_validate_edit_box, {
          title: `${_ctx.title}${i+1}`,
          placeholder: _ctx.placeholder,
          validation: _ctx.validation ? _ctx.validation[i] : undefined,
          required: _ctx.required,
          modelValue: _ctx.values[i],
          "onUpdate:modelValue": ($event: any) => (_ctx.values[i] = $event)
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(`${_ctx.title}${i+1}`), 1)
          ]),
          _: 2
        }, 1032, ["title", "placeholder", "validation", "required", "modelValue", "onUpdate:modelValue"]),
        _createVNode(_component_icon_button_large, {
          icon: "times",
          state: "delete",
          onClick: ($event: any) => (_ctx.deleteValue(i))
        }, null, 8, ["onClick"])
      ]))
    }), 128)),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_normal_button, {
        class: "add-button",
        state: "normal",
        onClick: _ctx.addValue
      }, {
        default: _withId(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
})